import {storeInstance} from '@aofl/store/dist/legacy';
import {
  sdoNs,
  products,
  userTypes
} from '@modules/constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
import '@modules/session-sdo';

const sdo = {
  namespace: sdoNs.DASHBOARD,
  mutations: {
    init() {
      return {
        searchTargetUrl: '',
        subGroupsLoading: true,
        queryObj: {
          filters: {}
        },
        defaultQueryObj: {
          filters: {}
        },
        pendingFilters: {},
        summary: {},
        week: {
          start: null,
          end: null,
        },
        dashboardGroupInfo: {},
        groupCreatedTimestamp: null,
      };
    },
    setSummary(subState, summary) {
      if (typeof summary.students === 'object') {
        summary.students = summary.students.total;
      }
      return deepAssign(subState, 'summary', summary);
    },
    setPendingFiltersStatsPath(subState, path) {
      return deepAssign(subState, 'pendingFilters', {
        stats_path: path
      });
    },
  },
  decorators: [
    (nextState) => { // $filterStatsPathDash, $atClassLevel, $activeGroupId
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.DASHBOARD];
      const subState = state[sdoNs.DASHBOARD];

      if (typeof nextSubState.$filterStatsPathDash === 'undefined'
          || typeof nextSubState.$activeGroupId === 'undefined'
          || typeof nextSubState.$atClassLevel === 'undefined'
          || nextState[sdoNs.SESSION].group_info !== state[sdoNs.SESSION].group_info
          || nextState[sdoNs.SESSION].$classLevel !== state[sdoNs.SESSION].$classLevel
          || nextSubState.pendingFilters?.stats_path !== subState.pendingFilters?.stats_path
          || nextSubState.dashboardGroupInfo !== subState.dashboardGroupInfo) {
        let $activeGroupId = nextState[sdoNs.SESSION].current_role.group_id;
        let $isDashboardGroup = false;
        let pathArray = [];
        let statsPath = [];
        if (Array.isArray(nextSubState.pendingFilters?.stats_path) &&
          nextSubState.pendingFilters.stats_path.length) {
          // for when URL is missing trailing . (i.e. 247777.247814 instead 247777.247814.
          if (typeof nextSubState.pendingFilters.stats_path[0] === 'number') {
            nextSubState.pendingFilters.stats_path[0] = nextSubState.pendingFilters.stats_path[0].toString() + '.';
          }
          statsPath = nextSubState.pendingFilters.stats_path[0].split('.');
        }
        statsPath.pop();
        if (statsPath.length >= 1) {
          $activeGroupId = parseInt(statsPath[statsPath.length - 1], 10);
          // we want to grab all groups below top level group
          pathArray = statsPath.slice(nextState[sdoNs.SESSION].group_info.level);
        }

        const $filterStatsPathDash = pathArray.map((groupId) => parseInt(groupId, 10));

        let $atClassLevel = false;
        if (
          ($filterStatsPathDash.length + nextState[sdoNs.SESSION].group_info.level) === nextState[sdoNs.SESSION].$classLevel
          || nextState[sdoNs.SESSION].type === userTypes.TEACHER) {
          $atClassLevel = true;
        }
        // this is the override of if we're looking at a dashboard group
        if (nextSubState.dashboardGroupInfo?.id) {
          $activeGroupId = nextSubState.dashboardGroupInfo.id;
          $isDashboardGroup = true;
        }
        nextState = deepAssign(nextState, sdoNs.DASHBOARD, {
          $filterStatsPathDash,
          $activeGroupId,
          $atClassLevel,
          $isDashboardGroup,
        });
      }
      return nextState;
    },
    (nextState) => { // $activityReportsMinDate
      const state = storeInstance.getState();
      const nextSessionState = nextState[sdoNs.SESSION];
      const nextSubState = nextState[sdoNs.DASHBOARD];
      const subState = state[sdoNs.DASHBOARD];

      if (
        nextState[sdoNs.SESSION].group_info !== state[sdoNs.SESSION].group_info ||
        nextSubState.$activeGroupId !== subState.$activeGroupId ||
        nextSubState.groupCreatedTimestamp !== subState.groupCreatedTimestamp
      ) {
        const defaultTimestamp = new Date(2021, 3, 11).getTime();
        const createdTimestamp = (nextSubState.groupCreatedTimestamp || nextSessionState.group_info.created_timestamp || 0) * 1000;
        const timestamp = Math.max(defaultTimestamp, createdTimestamp);
        const $activityReportsMinDate = new Date(timestamp);
        nextState = deepAssign(nextState, sdoNs.DASHBOARD, {
          $activityReportsMinDate
        });
      }

      return nextState;
    },
  ],
};

storeInstance.addState(sdo);
